import { mapKeys, upperFirst } from 'lodash';
export var createToolbarTheme = function (toolbarName, theme) {
    return mapKeys(theme, function (value, key) { return "" + toolbarName + upperFirst(key); });
};
